export default __webpack_public_path__ + "static/media/burger.2d8f03ea.svg";